import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-note-boilerplates-context',
  templateUrl: './note-boilerplates-context.component.html',
  styleUrls: ['./note-boilerplates-context.component.css']
})
export class NoteBoilerplatesContextComponent implements OnInit {

  @Input() positionX = 0;
  @Input() positionY = 0;
  @Input() actionsDisabled: boolean = false;
  @Input() clickedEmptySpace: boolean = false;

  @Output() edit = new EventEmitter<boolean>();
  @Output() addNew = new EventEmitter<boolean>();  
  @Output() delete = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  emitAddNew() {
    this.addNew.emit(true);
  }

  emitDelete() {
    this.delete.emit(true);
  }

  emitEdit() {
    this.edit.emit(true);
  }

}
